import { useEffect, useMemo } from "react";
import { IColumnProps } from "devextreme-react/data-grid";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";

import { createFormulaEditCellComponent } from "../../components/formulaEditor";
import { FormulaContextKeys } from "../../model/formula";

import { BaseMappings } from "./BaseMappings";
import { affixMappingColumns, dummyAffixMappingRow } from "./model/metaData";

const FORMULA_FIELDS = ["affixFormula"];

export const AffixMappings = (pageProps: PageProps) => {
  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const logger = pageProps.loggerProvider.getLogger("AffixMappings");
  logger.debug("Rendering AffixMappings component");

  const httpClient = pageProps.appUtil.httpClients["eAccountingService"];

  // Render the formula editor through the column's `editCellComponent` so the DataGrid's editing
  // controller supplies the current value and receives changes. A form-item template would bypass
  // that binding and open with an empty editor for existing rows.
  const formulaEditCellComponent = useMemo(
    () =>
      createFormulaEditCellComponent({
        httpClient,
        contextKey: FormulaContextKeys.TessituraContext,
        rootObjects: ["TransactionInfo"],
      }),
    [httpClient],
  );

  const columnConfigs = useMemo(() => {
    const configs = new Map<string, IColumnProps>(affixMappingColumns);
    FORMULA_FIELDS.forEach((field) => {
      const existing = configs.get(field) ?? { dataField: field };
      configs.set(field, { ...existing, editCellComponent: formulaEditCellComponent });
    });
    return configs;
  }, [formulaEditCellComponent]);

  const editorItemOptions = useMemo(() => {
    const options = new Map<string, IItemProps>([
      [
        "isPrefix",
        {
          editorType: "dxCheckBox",
        },
      ],
    ]);
    return options;
  }, []);

  return (
    <BaseMappings
      logger={logger}
      {...pageProps}
      baseUrl="affix-mappings"
      formTitle="Affix Mapping"
      dummyRow={dummyAffixMappingRow}
      columnConfigs={columnConfigs}
      additionalEditorItemOptions={editorItemOptions}
    />
  );
};
